import { FC } from 'react'
import Image from 'next/image'

import styles from './project-card-icon.module.scss'

interface IProjectCardIcon {
  count: number
  iconUrl: string
  altDesc: string
}

export const ProjectCardIcon: FC<IProjectCardIcon> = ({ count, iconUrl, altDesc }) => {
  return (
    <div className={styles.icon}>
      <Image src={iconUrl} width="18" height="18" alt={altDesc} />
      <p className={styles.iconCount}>{count}</p>
    </div>
  )
}

export default ProjectCardIcon
